export const isDateOlderThan = (date: string, days: number) => {
  const today: any = new Date();
  const exactDate: any = new Date(date);
  const daysHours = 24 * days;
  const daysMiliseconds = 60 * 60 * daysHours * 1000;

  return (today - exactDate) > daysMiliseconds;
};

export const numberOfDaysPassed = (date: string) => {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const today: any = new Date();
  const exactDate: any = new Date(date);

  return Math.round(Math.abs((today - exactDate) / oneDay));
};

export const toDate = (dateString?: string) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()); // Strip time portion
};

export const isWeekend = (datetime: any) => {
  const day = datetime?.weekday;
  return day === 6 || day === 7; // Disable Sunday (7) and Saturday (6)
}

export const formatDateForDocuments = (date: Date) => {
  const options: any = { year: 'numeric', month: 'short', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options);

  const hours = String(date.getHours()).padStart(2, '0'); // 2-digit hour
  const minutes = String(date.getMinutes()).padStart(2, '0'); // 2-digit minute

  return `${formattedDate}, ${hours}:${minutes}`;
};
// Epoch ms of midnight UTC on the date's UTC day, so two dates compare by day alone
export const toUTCDay = (date: string | number | Date) => new Date(date).setUTCHours(0, 0, 0, 0);
